<template>
  <div>
    <Articles :selectedPageTemplate="selectedPageTemplate"/>
  </div>
</template>

<script>
  export default {
    components: {
      Articles: () => import('@/components/Design/View/ViewTheme'),
    },
    data: () => ({
      selectedPageTemplate: 'Articles',
    }),
    created () {
    }
  }
</script>
